// extracted by mini-css-extract-plugin
export default {"container":"Ie87GGm92iQsEK9o5FeE"};